import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { BottomSheetComponent, DeviceService } from '@nomoh-monorepo/shared-common-ui';
import { TipoServicoCriarEditarComponent } from '../tipo-servico-modal/tipo-servico-criar-editar/tipo-servico-criar-editar.component';
import type { ITipoServico } from '@nomoh-monorepo/shared-types';
import { NichoTermosService } from '@nomoh-monorepo/data-access-bardo-administrador';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-tipo-servico-form-modal',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    BottomSheetComponent,
    TipoServicoCriarEditarComponent,
    TranslateModule,
  ],
  templateUrl: './tipo-servico-form-modal.component.html',
})
export class TipoServicoFormModalComponent {
  public deviceService = inject(DeviceService);
  $nicho = inject(NichoTermosService).$nicho;


  @Input() set visible(value: boolean) {
    this.$visible.set(value);
  }
  @Input() tipoServico: ITipoServico | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() salvo = new EventEmitter<string>(); // Emits the created/updated ID

  @ViewChild('tipoCriarRef')
  tipoCriarRef?: TipoServicoCriarEditarComponent;

  $visible = signal<boolean>(false);
  $isLoading = signal<boolean>(false);

  fecharModal() {
    this.$visible.set(false);
    this.visibleChange.emit(false);
  }

  onSheetVisibleChange(visivel: boolean) {
    if (visivel) {
      this.$visible.set(true);
    } else {
      this.fecharModal();
    }
  }

  salvar() {
    this.tipoCriarRef?.salvar();
  }

  onCategoriaSalva(id: string) {
    this.salvo.emit(id);
    this.fecharModal();
  }
}
